import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [
    'line',
    'scanCheckbox',
    'scanField',
    'manualList',
    'manualTemplate',
    'locationSelect',
    'destinationSelect',
  ];

  connect() {
    const attr = this.element.getAttribute('data-items--harvest-next-index');
    const fromAttr = attr ? parseInt(attr, 10) : NaN;
    this.nextIndex = Number.isFinite(fromAttr) ? fromAttr : this.lineTargets.length;
    this.syncAllLocationRequirements();
  }

  locationRequiredDestinations() {
    try {
      const raw = this.element.getAttribute('data-items--harvest-location-required-destinations');
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (_error) {
      return ['harvest_for_reuse', 'manufacturer_take_back'];
    }
  }

  syncAllLocationRequirements() {
    this.lineTargets.forEach((line) => this.syncLocationRequirement(line));
  }

  toggleLocationRequired(event) {
    const line = event.currentTarget.closest('[data-items--harvest-target="line"]');
    if (line) this.syncLocationRequirement(line);
  }

  syncLocationRequirement(line) {
    const destinationSelect = line.querySelector('[data-items--harvest-target="destinationSelect"]');
    const locationSelect = line.querySelector('[data-items--harvest-target="locationSelect"]');
    if (!destinationSelect || !locationSelect) return;

    const required = this.locationRequiredDestinations().includes(destinationSelect.value);
    locationSelect.required = required;
    if (!required) locationSelect.setCustomValidity('');
  }

  addManualLine(event) {
    event.preventDefault();
    event.stopPropagation();

    const list = this.findManualList();
    const templateEl = this.findManualTemplate();
    if (!list || !templateEl) return;

    const index = this.nextIndex;
    this.nextIndex += 1;

    let html = '';
    if (templateEl.content) {
      const wrapper = document.createElement('div');
      wrapper.appendChild(templateEl.content.cloneNode(true));
      html = wrapper.innerHTML;
    } else {
      html = templateEl.innerHTML;
    }

    html = html
      .replace(/HARVEST_COMPONENT_INDEX/g, String(index))
      .replace(/__INDEX__/g, String(index));

    list.insertAdjacentHTML('beforeend', html);

    const lines = list.querySelectorAll('[data-items--harvest-target="line"]');
    const lastLine = lines[lines.length - 1];
    if (!lastLine) return;

    this.syncLocationRequirement(lastLine);

    const nameField = lastLine.querySelector('input[name*="[harvest_attribute_name]"]');
    if (nameField) nameField.focus();
    lastLine.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  findManualList() {
    if (this.hasManualListTarget) return this.manualListTarget;
    return this.element.querySelector('[data-items--harvest-target="manualList"]');
  }

  findManualTemplate() {
    if (this.hasManualTemplateTarget) return this.manualTemplateTarget;
    return this.element.querySelector('[data-items--harvest-target="manualTemplate"]');
  }

  removeLine(event) {
    event.preventDefault();
    event.stopPropagation();
    const button = event.currentTarget;
    const line = button.closest('[data-items--harvest-target="line"]');
    if (line) line.remove();
  }

  addAttribute(event) {
    event.preventDefault();
    const scope = event.currentTarget.closest('[data-harvest-attrs]');
    if (!scope) return;

    const picker = scope.querySelector('[data-harvest-attr-picker]');
    const list = scope.querySelector('[data-harvest-attr-list]');
    if (!picker || !list) return;

    const attrIndex = picker.value;
    if (attrIndex === '') return;
    if (list.querySelector(`[data-attr-field="${attrIndex}"]`)) return;

    const template = scope.querySelector(
      `template[data-harvest-attr-template][data-attr-index="${attrIndex}"]`
    );
    if (!template) return;

    list.appendChild(
      template.content ? template.content.cloneNode(true) : document.createRange().createContextualFragment(template.innerHTML)
    );

    const option = picker.querySelector(`option[value="${attrIndex}"]`);
    if (option) option.disabled = true;
    picker.value = '';
  }

  removeAttribute(event) {
    event.preventDefault();
    const field = event.currentTarget.closest('[data-attr-field]');
    if (!field) return;

    const scope = event.currentTarget.closest('[data-harvest-attrs]');
    const attrIndex = field.getAttribute('data-attr-field');
    field.remove();

    if (scope) {
      const option = scope.querySelector(
        `[data-harvest-attr-picker] option[value="${attrIndex}"]`
      );
      if (option) option.disabled = false;
    }
  }

  toggleScan(event) {
    const checkbox = event.currentTarget;
    const line = checkbox.closest('[data-items--harvest-target="line"]');
    if (!line) return;

    const scanField = line.querySelector('[data-items--harvest-target="scanField"]');
    if (!scanField) return;

    scanField.style.display = checkbox.checked ? '' : 'none';
  }
}
